module.exports = __webpack_public_path__ + "fonts/Mount-Regular.4ec7b3e.woff";